function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useState, forwardRef } from 'react';
import snakeCase from 'lodash.snakecase';
import { LabelWrapper, InputWrapper, InputContainer, InputTextArea } from './styles';
import { LabelSubtitle } from '../label';
import HelpText from '../helpText';
import { jsx as ___EmotionJSX } from "@emotion/core";
export { default as ReduxTextArea } from './reduxTextArea';
export { default as FormikTextArea } from './formik';
var TextArea = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var label = _ref.label,
      hideLabel = _ref.hideLabel,
      subtitle = _ref.subtitle,
      horizontal = _ref.horizontal,
      help = _ref.help,
      errorMessage = _ref.errorMessage,
      etc = _objectWithoutProperties(_ref, ["label", "hideLabel", "subtitle", "horizontal", "help", "errorMessage"]);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isFocused = _useState2[0],
      setIsFocused = _useState2[1];

  var ariaLabel = hideLabel ? label : undefined;
  var id = etc.id || etc.name;
  var isTouched = etc.isTouched,
      isWarning = etc.isWarning,
      isErrored = etc.isErrored;
  return ___EmotionJSX(InputContainer, {
    horizontal: horizontal,
    pushRight: horizontal && hideLabel,
    "data-test": snakeCase("".concat(id, " container"))
  }, !hideLabel && ___EmotionJSX(LabelWrapper, {
    htmlFor: etc.name,
    horizontal: horizontal,
    "data-test": snakeCase("".concat(id, " label"))
  }, label, subtitle && ___EmotionJSX(LabelSubtitle, null, subtitle)), ___EmotionJSX(InputWrapper, {
    horizontal: horizontal
  }, ___EmotionJSX(InputTextArea, _extends({
    ref: ref,
    "data-test": snakeCase("".concat(id, " input")),
    "aria-label": ariaLabel,
    id: id,
    rows: 3,
    isTouched: isTouched,
    isFocused: isFocused,
    isWarning: isWarning,
    isErrored: isErrored
  }, etc, {
    onFocus: function onFocus(e) {
      var _etc$onFocus;

      setIsFocused(true);
      (_etc$onFocus = etc.onFocus) === null || _etc$onFocus === void 0 ? void 0 : _etc$onFocus.call(etc, e);
    },
    onBlur: function onBlur(e) {
      var _etc$onBlur;

      setIsFocused(false);
      (_etc$onBlur = etc.onBlur) === null || _etc$onBlur === void 0 ? void 0 : _etc$onBlur.call(etc, e);
    }
  })), ___EmotionJSX(HelpText, {
    text: help
  }), isTouched && (isErrored || isWarning) && ___EmotionJSX(HelpText, {
    text: errorMessage,
    isErrored: isErrored,
    isWarning: isWarning
  })));
});
TextArea.displayName = 'TextArea';
export default TextArea;